import { Link as GatsbyLink } from "gatsby"
import React from "react"
import i18n from "../../i18n/config"

export default function Link({ children, to, classNames, id }) {
  let path
  if (i18n.language === "es") {
    path = `/${i18n.language}${to}`
  } else {
    path = to
  }
  return (
    <GatsbyLink id={id} className={classNames} to={path}>
      {children}
    </GatsbyLink>
  )
}
